<script>
    import {
        DecimalInput,
        NotificationModal,
    } from "../../../Components/Common/index.svelte";
    import ModifyFreeTextItemModal from "./codeSelector/freeTextComponents/ModifyFreeTextItemModal.svelte";

    export let isModifyItemModalOpen = false;
    export let isUpdatingItems = false;
    export let itemDetails = {
        itemNum: Number(0),
        rebate: Number(0),
        feeCharged: Number(0),
        fieldChange: Number(0),
        encounterItemDescription: "",
    };
    export let defaultItem = {};
    export let saveBillingItem = () => {};
    export let closeModal = () => {};

    $: isItemsUsingASA = itemDetails.isUsingAsaItems;
    $: isItemsUsingFreeText = itemDetails.isUsingFreeTextItems;

    const MAX_CHARS = 50;

    let showItemDescriptionExceedingMaxChars = false;

    const handleItemDescriptionInput = (e) => {
        const description = e.target.value;

        showItemDescriptionExceedingMaxChars = description.length > MAX_CHARS;

        itemDetails.encounterItemDescription =
            showItemDescriptionExceedingMaxChars
                ? description.slice(0, MAX_CHARS)
                : description;
    };

    const closeItemModal = () => closeModal();

    const saveItem = async () => await saveBillingItem(itemDetails, "edit");

    // HELPER FUNCTIONS
</script>

{#if isItemsUsingFreeText}
    <ModifyFreeTextItemModal
        isModalOpen={isModifyItemModalOpen}
        itemObj={itemDetails}
        closeModal={closeItemModal}
        confirmAction={saveItem}
        isConfirming={isUpdatingItems}
    />
{:else}
    <NotificationModal
        title={`Edit ${isItemsUsingASA ? "ASA Billing" : "MBS Billing"} Item`}
        isModalOpen={isModifyItemModalOpen}
        cancelText="Cancel"
        submitText={`${isUpdatingItems ? " Submitting" : "Submit"} `}
        isConfirming={isUpdatingItems}
        closeModal={closeItemModal}
        confirmAction={saveItem}
        closeModalFunction={closeItemModal}
    >
        <div class="flex flex-1 flex-col gap-y-4 relative overflow-y-scroll">
            <div class="flex gap-x-4">
                <p class="w-48">Item {isItemsUsingASA ? "Code" : "Number"}:</p>

                <input
                    type="text"
                    class="input input-sm w-full"
                    value={isItemsUsingASA
                        ? defaultItem.itemCode
                        : defaultItem.itemNum}
                    disabled
                />
            </div>

            <div class="flex gap-x-4">
                <p class="w-48">Fee Charged:</p>
                <DecimalInput
                    inputClass="w-full"
                    bind:value={itemDetails.feeCharged}
                    isDisabled={!isItemsUsingFreeText}
                />
            </div>

            <div class="flex gap-x-4">
                <p class="w-48">Rebate:</p>
                <DecimalInput
                    inputClass="w-full"
                    value={itemDetails.rebate}
                    isDisabled
                />
            </div>

            <div class="flex flex-col gap-y-2">
                <p class="w-48">Item Note:</p>

                <input
                    type="text"
                    class="input input-sm input-bordered w-full"
                    bind:value={itemDetails.encounterItemDescription}
                    on:input={handleItemDescriptionInput}
                    on:blur={handleItemDescriptionInput}
                />

                {#if showItemDescriptionExceedingMaxChars}
                    <p class="text-error cursor-default">
                        Item notes can by up to {MAX_CHARS} characters.
                    </p>
                {/if}
            </div>
        </div>
    </NotificationModal>
{/if}
